import { Injectable, inject } from '@angular/core';
import { Tracking } from '@freelancer/tracking';
import type { ApplicationType } from './payments-tracking.types';

interface TrackingData {
  action?: string;
  label?: string;
  name?: string;
  value?: string;
  reference?: string;
  referenceId?: number;
}

@Injectable({
  providedIn: 'root',
})
export class PaymentsTrackingService {
  private tracking = inject(Tracking);

  private section: ApplicationType;

  initiate(section: ApplicationType): void {
    this.section = section;
  }

  pushTrackingData(trackingData: TrackingData): void {
    this.handleTrackingEvent(trackingData);
  }

  private handleTrackingEvent(trackingData: TrackingData): void {
    this.tracking.track('user_action', {
      section: this.section,
      action: trackingData.action,
      label: trackingData.label,
      extra_params: {
        name: trackingData.name,
        value: trackingData.value,
        reference: trackingData.reference,
        reference_id: trackingData.referenceId,
      },
    });
  }
}
